import React from 'react';

import ConceptCheckPlayer from '../ConceptCheckPlayer';
import useConceptCheckPlayer from '../../../hooks/useConceptCheckPlayer';

function ConceptCheckPlayerBox() {
  const [
    conceptPopupInfo,
    setConceptPopup,
  ] = useConceptCheckPlayer();  // 개념확인 팝업
  
  return (
    <React.Fragment>
      {
        conceptPopupInfo.onOff && (
          <ConceptCheckPlayer
            title={conceptPopupInfo.title}
            url={conceptPopupInfo.url}
            onHide={setConceptPopup}
          />
        )
      }
    </React.Fragment>
  );
}

export default ConceptCheckPlayerBox;
